<style lang="css">
.account-search-box {
  position: absolute;
  right: 20px;
  top: 8px;
  height: 36px;
  border: 1px solid #ccc;
  overflow: hidden;
}
</style>
<template>
  <div class="sel-modal clearfix">
    <div class="sel-modal-header clearfix">
      <vxe-radio-group v-model="selectTab">
        <ul class="tab-list">
          <li>
            <vxe-radio name="xtabs" label="tab">{{ logisticsType === 1 ? '选择司机列表' : '选择个人列表' }}</vxe-radio>
          </li>
        </ul>
      </vxe-radio-group>
      <div class="account-search-box">
        <vxe-input
            style="height: 34px !important;"
            v-model="username"
            type="search"
            placeholder="搜索"
            @keyup.enter.native="search"
            @search-click="search"
        ></vxe-input>
      </div>
    </div>
    <div>
      <vxe-table
          :loading='loading'
          show-overflow
          stripe
          highlight-current-row
          highlight-hover-row
          border="none"
          ref="xTable1"
          height="430"
          align="center"
          :auto-resize="true"
          :data="driverData"
          @current-change="currentChangeEvent"
      >
        <!--        <vxe-table-column field="userName" title="客户名称"></vxe-table-column>-->
        <vxe-table-column field="realName" title="姓名"></vxe-table-column>
        <vxe-table-column field="regisiterNum" title="电话号码"></vxe-table-column>
      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="page.currentPage"
          :page-size.sync="page.pageSize"
          :total="page.totalResult"
          @page-change="changePage"
      ></vxe-pager>
    </div>
  </div>
</template>

<script>
import $api from "@/apiProvider";

export default {
  name: "Account",
  data() {
    return {
      loading: false,
      selectTab: "tab",
      username: null,
      driverData: [],
      page: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 100,
      },
      logisticsType: 1
    };
  },
  created() {
  },
  methods: {
    changePage(e) {
      this.page.currentPage = e.currentPage;
      this.page.pageSize = e.pageSize;
      this.queryDriver();
    },
    currentChangeEvent({row}) {
      this.$emit("choose", row, 1);
    },
    search() {
      // 搜索企业用户列表
      this.page.currentPage = 1;
      this.page.pageSize = 10;
      this.queryDriver();
    },
    init(logisticsType) {
      this.logisticsType = logisticsType;
      this.username = null;
      this.page.currentPage = 1;
      this.queryDriver();
    },
    async queryDriver() {
      this.loading = true;
      let obj = this.logisticsType === 1 ? {
        username: this.username,
        userType: 1,
        userCategory: 5,
        orderBy: 2,
        page: this.page.currentPage,
        rows: this.page.pageSize,
      } : {
        userType: 1,
        username: this.username,
        orderBy: 2,
        page: this.page.currentPage,
        rows: this.page.pageSize,
      }
      let res = await $api.gcdUser.request(this.logisticsType === 1 ? 'queryDriverList' : "queryUserListWithoutPermission2", obj);
      this.loading = false
      if (res.status === 1) {
        this.page.totalResult = res.data.total;
        if (this.logisticsType === 1) {
          res.data.rows.map(i => {
            i.regisiterNum = i.loginName;
          })
        }
        this.driverData = res.data.rows;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    close() {
      this.username = null;
      this.page = {
        currentPage: 1,
        pageSize: 10,
        totalResult: 100,
      };
      this.$refs.xTable1.clearCurrentRow();
    },
  },
};
</script>

<style>
</style>